import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/assistant`;

const assistantService = {
  runQuery: (facilityId, query) => apiClient.post(`${base(facilityId)}/query`, { query }),
  getIntents: (facilityId) => apiClient.get(`${base(facilityId)}/intents`),
};

export default assistantService;
